import React, { useEffect } from 'react';
import { Helmet } from "react-helmet-async";
import { Award, BookOpen, CheckCircle, Clock, Sparkles } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function DiplomaContent() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="py-5" style={{ background: '#f8fafc', minHeight: '85vh' }}>
      <Helmet>
        <title>Diploma in Theology - Vidyajyoti College of Theology</title>
        <meta name="description" content="Three-year Diploma in Theology at Vidyajyoti College of Theology, Delhi." />
        <meta name="keywords" content="Diploma in Theology, Theology Diploma Delhi, Catholic Diploma, Vidyajyoti courses" />
        <link rel="canonical" href="/academics/diploma" />
      </Helmet>

      <div className="container">
        {/* Header Hero */}
        <div className="card border-0 rounded-4 shadow-sm p-4 p-md-5 mb-5" style={{ background: 'linear-gradient(135deg, #1a2b56 0%, #2a3f75 100%)', color: '#fff' }}>
          <div className="row align-items-center">
            <div className="col-lg-8">
              <div className="d-inline-flex align-items-center gap-2 px-3 py-1 rounded-pill mb-3" style={{ background: 'rgba(198, 146, 20, 0.2)', color: '#ffd56b', fontSize: '0.85rem', fontWeight: 600 }}>
                <Sparkles size={14} /> Diploma Programme
              </div>
              <h1 className="display-6 fw-bold mb-2" style={{ fontFamily: "'Outfit', sans-serif" }}>
                Diploma in Theology
              </h1>
              <p className="lead mb-0 text-light" style={{ fontSize: '1.02rem', lineHeight: '1.7', opacity: 0.9 }}>
                A flexible three-year theological formation curriculum designed for students who desire a solid foundational grounding in Sacred Scripture, Systematic Theology, Moral Theology, and Pastoral Ministry without undertaking the formal B.Th. degree dissertation.
              </p>
            </div>
            <div className="col-lg-4 text-center mt-4 mt-lg-0">
              <div className="p-4 rounded-4" style={{ background: 'rgba(255, 255, 255, 0.08)', backdropFilter: 'blur(10px)', border: '1px solid rgba(255, 255, 255, 0.15)' }}>
                <Award size={40} className="mb-2" style={{ color: '#ffd56b' }} />
                <h5 className="fw-bold mb-1 text-white">3 Years Curriculum</h5>
                <p className="small mb-0 text-light opacity-75">Comprehensive Coursework</p>
                <hr style={{ borderColor: 'rgba(255,255,255,0.2)' }} />
                <Link to="/admission/details" className="btn btn-sm w-100 rounded-pill fw-semibold text-white" style={{ background: '#79031d' }}>
                  Apply for Admission
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Feature Highlights */}
        <div className="row g-4">
          <div className="col-md-6">
            <div className="card h-100 border-0 rounded-4 shadow-sm p-4 p-md-5 bg-white">
              <div className="d-flex align-items-center gap-3 mb-3">
                <div className="p-3 rounded-circle" style={{ background: 'rgba(26,43,86,0.08)', color: '#1a2b56' }}>
                  <BookOpen size={24} />
                </div>
                <h4 className="fw-bold mb-0" style={{ color: '#1a2b56' }}>Programme Scope</h4>
              </div>
              <p className="text-muted" style={{ lineHeight: '1.8', textAlign: 'justify' }}>
                Students who do not wish to do the B.Th. degree course may opt for the three-year Diploma course. They are exempt from writing the formal Dissertation and select academic requirements as designated by the Principal, making it ideal for pastoral workers, religious sisters, and lay catechists.
              </p>
            </div>
          </div>

          <div className="col-md-6">
            <div className="card h-100 border-0 rounded-4 shadow-sm p-4 p-md-5 bg-white">
              <div className="d-flex align-items-center gap-3 mb-3">
                <div className="p-3 rounded-circle" style={{ background: 'rgba(121,3,29,0.08)', color: '#79031d' }}>
                  <Clock size={24} />
                </div>
                <h4 className="fw-bold mb-0" style={{ color: '#79031d' }}>Examination &amp; Completion</h4>
              </div>
              <ul className="list-unstyled d-flex flex-column gap-3 mb-0">
                <li className="d-flex align-items-start gap-2">
                  <CheckCircle size={18} className="text-success flex-shrink-0 mt-1" />
                  <span className="text-muted small">Completion of prescribed theological credit courses over 3 academic years.</span>
                </li>
                <li className="d-flex align-items-start gap-2">
                  <CheckCircle size={18} className="text-success flex-shrink-0 mt-1" />
                  <span className="text-muted small">One-hour final comprehensive oral/written examination before the faculty board.</span>
                </li>
                <li className="d-flex align-items-start gap-2">
                  <CheckCircle size={18} className="text-success flex-shrink-0 mt-1" />
                  <span className="text-muted small">Award of the Vidyajyoti Diploma in Theology during the annual convocation.</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
